
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  useTheme,
  Typography,
} from '@mui/material';
import { useMeetingQuery } from '@modules/Meetings/hooks/useMeetingQuery';
import { FeedbackForm } from '@modules/Feedback/FeedbackForm';


type FormCrud = Feedback.Crud;

type Props = {
    open: boolean;
    onClose: () => void;
    options: {
        meetingId: number,
        defaultValues?: Partial<FormCrud>;
    };
};

export const EditMeetingFeedbackDialog: React.FC<Props> = ({
  open,
  onClose,
  options,
}) => {
  const theme = useTheme();
  const { meetingId } = options || {};
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { meeting } = useMeetingQuery({ id: meetingId }, { enabled: !!meetingId });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      fullScreen={isMobile}
    >
      <DialogTitle>
        <Typography variant="h1">Edit your feedback</Typography>
        <Typography variant="body2">
          {meeting ? meeting.title : 'Loading...'}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <FeedbackForm meetingId={meetingId} defaultValues={meeting?.feedback} feedbackId={meeting?.feedback?.id} onClose={onClose}/>
      </DialogContent>
    </Dialog>
  );
};
